import * as R from "ramda";
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { TextField, DateField } from "react-admin";
import PropTypes from "prop-types";
import { Typography, Card, CardContent, Avatar } from "@material-ui/core";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import EmailIcon from "@material-ui/icons/Email";
import WcIcon from "@material-ui/icons/Wc";
import FaceIcon from "@material-ui/icons/Face";
import { fetchConsumerUserData } from "../../redux/patients/saga";

const asideStyles = (theme) => ({
  root: {
    width: 400,
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
});

class Aside extends React.Component {
  constructor(props) {
    super(props);
    this.state = { consumerInfo: null };
    this.uploadConsumerInfo = this.uploadConsumerInfo.bind(this);
  }

  uploadConsumerInfo(record, nextProps) {
    if (this.state.consumerInfo) {
      return;
    }
    fetchConsumerUserData(record.id).then((data) => {
      this.setState({ consumerInfo: data });
    });
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { record } = nextProps;
    if (record && record.auth_token) {
      this.uploadConsumerInfo(record);
    }
  }

  render() {
    let { record, classes, basePath } = this.props;
    if (this.state.consumerInfo) {
      record = { ...record, ...{ consumerInfo: this.state.consumerInfo } };
    } else {
      return null;
    }

    return (
      <div className={classes.root}>
        {record && <ConsumerData record={record} basePath={basePath} />}
      </div>
    );
  }
}

Aside.propTypes = {
  record: PropTypes.any,
  basePath: PropTypes.string,
};

const ConsumerData = ({ record, basePath }) => {
  const userId = R.pathOr(null, ["consumerInfo", "id"], record);
  const urlToConsumerAdmin = (email) => {
    return `${window.config.apiRoot}/redirect-to-consumer-admin/${userId}`;
  };
  const username = `${R.pathOr(
    "-",
    ["consumerInfo", "first_name"],
    record
  )} ${R.pathOr("-", ["consumerInfo", "last_name"], record)}`;
  return (
    <>
      <div style={{ margin: "0 0 1em 1em" }}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              <a href={urlToConsumerAdmin(userId)} target="_blank">
                Consumer Info
              </a>
            </Typography>
            {record.consumerInfo.avatar_url && (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Avatar
                  src={record.consumerInfo.avatar_url}
                  style={{ width: "150px", height: "150px" }}
                />
              </div>
            )}
            <div style={{ display: "flex", marginTop: "15px" }}>
              <div style={{ flexGrow: 1, width: "160px" }}>
                <div style={{ display: "flex" }}>
                  <FaceIcon fontSize="small" color="disabled" />
                  <div style={{ flexGrow: 1 }}>
                    <span>{username}</span>
                  </div>
                </div>
              </div>
              <div style={{ flexGrow: 1 }}>
                <div style={{ display: "flex" }}>
                  <div mr="1em">
                    <WcIcon fontSize="small" color="disabled" />
                  </div>
                  <div style={{ flexGrow: 1 }}>
                    <TextField record={record.consumerInfo} source="gender" />
                  </div>
                </div>
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div style={{ flexGrow: 1 }}>
                <div style={{ display: "flex", width: "160px" }}>
                  <EmailIcon fontSize="small" color="disabled" />
                  <div style={{ flexGrow: 1 }}>
                    <TextField record={record.consumerInfo} source="email" />
                  </div>
                </div>
              </div>
              <div style={{ flexGrow: 1 }}>
                <div style={{ display: "flex" }}>
                  <AccessTimeIcon fontSize="small" color="disabled" />
                  <div style={{ flexGrow: 1 }}>
                    <DateField
                      record={record.consumerInfo}
                      source="date_of_birth"
                    />
                  </div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default withStyles(asideStyles)(Aside);
